import { companyService } from "../services/companies";
import { sectorService } from "../services/sectors";
import { clearAllTables } from "../utils/ui_utils";
import { hideMenu } from "../shared.js";

export class PlanController {
  constructor() {
    this.currentStep = 1;
    this.totalSteps = 5;
    this.planData = {
      plan_name: "",
      plan_date: "",
      company_id: "",
      sector_id: "",
      supply_program: {},
    };
  }

  async init(currBtn) {
    this.updateUI(currBtn);
    await this.renderPlanCreationInterface();
  }

  updateUI(currBtn) {
    // Clear active states and set current button as active
    document.querySelectorAll(".menu__btn").forEach((btn) => {
      btn.classList.remove("menu__btn--active");
    });
    currBtn.classList.add("menu__btn--active");

    hideMenu();
    // Clear all tables including plan nav
    clearAllTables(true);
  }

  async renderPlanCreationInterface() {
    const planTableWindow = document.querySelector(".plan_table_window");
    if (!planTableWindow) return;

    // Get companies for the dropdown
    const companiesResult = await companyService.listCompanies();
    const companies = companiesResult.success ? companiesResult.data : [];

    planTableWindow.innerHTML = `
      <div class="container-fluid p-0">
        <div class="row">
          <div class="col-12">
            <div class="card border-0">
              <!-- Progress Header -->
              <div class="card-header" style="background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%); border: none; padding: 1.5rem;">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <div class="bg-white rounded-circle p-2 me-3" style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                      <i class="bi bi-calendar-plus" style="color: #59a370; font-size: 1.2rem;"></i>
                    </div>
                    <div>
                      <h5 class="card-title mb-0 text-white fw-bold">Nuovo Piano di Fertirrigazione</h5>
                      <small class="text-white opacity-75">Step ${
                        this.currentStep
                      } di ${this.totalSteps}</small>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Progress Bar -->
              <div class="progress" style="height: 4px; border-radius: 0;">
                ${this.renderProgressBar()}
              </div>

              <!-- Step Content -->
              <div class="card-body p-4">
                <!-- Step Indicator -->
                <div class="d-flex justify-content-between mb-4">
                  ${this.renderStepIndicators()}
                </div>

                <!-- Step 1 Content -->
                <div id="step1Content" class="step-content">
                  <form id="planBasicDataForm" class="needs-validation" novalidate>
                    <div class="row g-4">
                      <!-- Plan Name -->
                      <div class="col-md-6">
                        <label for="planName" class="form-label fw-semibold">Nome Piano</label>
                        <input type="text" 
                          class="form-control form-control-lg" 
                          id="planName" 
                          name="planName" 
                          required
                          placeholder="Inserisci il nome del piano"
                          style="border: 2px solid #e2e8f0; border-radius: 10px;">
                        <div class="invalid-feedback">
                          Inserisci un nome per il piano
                        </div>
                      </div>

                      <!-- Plan Date -->
                      <div class="col-md-6">
                        <label for="planDate" class="form-label fw-semibold">Data</label>
                        <input type="date" 
                          class="form-control form-control-lg" 
                          id="planDate" 
                          name="planDate" 
                          required
                          value="${new Date().toISOString().split("T")[0]}"
                          style="border: 2px solid #e2e8f0; border-radius: 10px;">
                        <div class="invalid-feedback">
                          Seleziona una data
                        </div>
                      </div>

                      <!-- Company Selection -->
                      <div class="col-md-6">
                        <label for="companySelect" class="form-label fw-semibold">Azienda</label>
                        <select class="form-select form-select-lg" 
                          id="companySelect" 
                          name="companySelect" 
                          required
                          style="border: 2px solid #e2e8f0; border-radius: 10px;">
                          <option value="">Seleziona un'azienda</option>
                          ${companies
                            .map(
                              (company) => `
                            <option value="${company.id}">${company.company_name}</option>
                          `
                            )
                            .join("")}
                        </select>
                        <div class="invalid-feedback">
                          Seleziona un'azienda
                        </div>
                      </div>

                      <!-- Sector Selection (populated after company selection) -->
                      <div class="col-md-6">
                        <label for="sectorSelect" class="form-label fw-semibold">Settore</label>
                        <select class="form-select form-select-lg" 
                          id="sectorSelect" 
                          name="sectorSelect" 
                          required
                          disabled
                          style="border: 2px solid #e2e8f0; border-radius: 10px;">
                          <option value="">Seleziona un settore</option>
                        </select>
                        <div class="invalid-feedback">
                          Seleziona un settore
                        </div>
                      </div>
                    </div>

                    <!-- Navigation Buttons -->
                    <div class="d-flex justify-content-end mt-5">
                      <button type="submit" class="btn btn-success btn-lg px-5" style="border-radius: 10px;">
                        <i class="bi bi-arrow-right me-2"></i>
                        Continua
                      </button>
                    </div>
                  </form>
                </div>

                <!-- Step 2 Content (hidden initially) -->
                <div id="step2Content" class="step-content" style="display: none;">
                  <div class="row">
                    <div class="col-12">
                      <div class="alert alert-info">
                        <i class="bi bi-info-circle me-2"></i>
                        <strong>Valori consigliati per la coltura selezionata</strong>
                      </div>
                      
                      <div class="table-responsive mt-4">
                        <table class="table table-bordered">
                          <thead class="table-light">
                            <tr>
                              <th>Apporti</th>
                              <th>N</th>
                              <th>P2O5</th>
                              <th>K2O</th>
                              <th>CaO</th>
                              <th>MgO</th>
                              <th>SO3</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Apporti consigliati</td>
                              <td id="suggestedN">-</td>
                              <td id="suggestedP">-</td>
                              <td id="suggestedK">-</td>
                              <td id="suggestedCa">-</td>
                              <td id="suggestedMg">-</td>
                              <td id="suggestedS">-</td>
                            </tr>
                            <tr>
                              <td>Apporti da programmare</td>
                              <td>
                                <input type="number" class="form-control" id="plannedN" step="0.01" min="0">
                              </td>
                              <td>
                                <input type="number" class="form-control" id="plannedP" step="0.01" min="0">
                              </td>
                              <td>
                                <input type="number" class="form-control" id="plannedK" step="0.01" min="0">
                              </td>
                              <td>
                                <input type="number" class="form-control" id="plannedCa" step="0.01" min="0">
                              </td>
                              <td>
                                <input type="number" class="form-control" id="plannedMg" step="0.01" min="0">
                              </td>
                              <td>
                                <input type="number" class="form-control" id="plannedS" step="0.01" min="0">
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <!-- Navigation Buttons -->
                      <div class="d-flex justify-content-between mt-5">
                        <button type="button" class="btn btn-outline-secondary btn-lg px-5" id="backToStep1" style="border-radius: 10px;">
                          <i class="bi bi-arrow-left me-2"></i>
                          Indietro
                        </button>
                        <button type="button" class="btn btn-success btn-lg px-5" id="goToStep3" style="border-radius: 10px;">
                          <i class="bi bi-arrow-right me-2"></i>
                          Continua
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    this.attachEventListeners();
  }

  renderProgressBar() {
    const progressPercentage =
      ((this.currentStep - 1) / (this.totalSteps - 1)) * 100;
    return `
      <div class="progress-bar" 
        role="progressbar" 
        style="width: ${progressPercentage}%; background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%);" 
        aria-valuenow="${progressPercentage}" 
        aria-valuemin="0" 
        aria-valuemax="100">
      </div>
    `;
  }

  renderStepIndicators() {
    const steps = [
      { number: 1, title: "Dati nuovo piano" },
      { number: 2, title: "Progr. Apporti" },
      { number: 3, title: "Progr. concime" },
      { number: 4, title: "Programma Fertirr." },
      { number: 5, title: "Riepilogo" },
    ];

    return steps
      .map(
        (step) => `
      <div class="text-center position-relative" style="flex: 1;">
        <div class="step-indicator ${
          this.currentStep >= step.number ? "active" : ""
        }" 
          style="
            width: 35px; 
            height: 35px; 
            border-radius: 50%; 
            background: ${
              this.currentStep >= step.number
                ? "linear-gradient(135deg, #59a370 0%, #4a8c62 100%)"
                : "#e2e8f0"
            }; 
            color: ${this.currentStep >= step.number ? "white" : "#64748b"}; 
            display: flex; 
            align-items: center; 
            justify-content: center;
            margin: 0 auto 10px;
            font-weight: 600;
            transition: all 0.3s ease;
          ">
          ${step.number}
        </div>
        <div class="step-title" style="color: ${
          this.currentStep >= step.number ? "#59a370" : "#64748b"
        }; font-weight: 500;">
          ${step.title}
        </div>
      </div>
    `
      )
      .join("");
  }

  attachEventListeners() {
    // Company selection change handler
    const companySelect = document.getElementById("companySelect");
    if (companySelect) {
      companySelect.addEventListener("change", async (e) => {
        const companyId = e.target.value;
        await this.updateSectorSelect(companyId);
      });
    }

    // Form submission handler
    const planBasicDataForm = document.getElementById("planBasicDataForm");
    if (planBasicDataForm) {
      planBasicDataForm.addEventListener("submit", async (e) => {
        e.preventDefault();
        if (planBasicDataForm.checkValidity()) {
          await this.handleStep1Submission();
        }
        planBasicDataForm.classList.add("was-validated");
      });
    }

    // Back button handler
    const backToStep1 = document.getElementById("backToStep1");
    if (backToStep1) {
      backToStep1.addEventListener("click", () => {
        this.goToStep(1);
      });
    }

    // Continue to step 3 handler
    const goToStep3 = document.getElementById("goToStep3");
    if (goToStep3) {
      goToStep3.addEventListener("click", () => {
        // Validate and save step 2 data
        if (this.validateStep2Data()) {
          this.saveStep2Data();
          this.goToStep(3);
        }
      });
    }
  }

  async updateSectorSelect(companyId) {
    const sectorSelect = document.getElementById("sectorSelect");
    if (!sectorSelect) return;

    if (!companyId) {
      sectorSelect.innerHTML = '<option value="">Seleziona un settore</option>';
      sectorSelect.disabled = true;
      return;
    }

    try {
      const sectorsResult = await sectorService.listSectorsByCompany(companyId);
      const sectors = sectorsResult.success ? sectorsResult.data : [];

      sectorSelect.innerHTML = `
        <option value="">Seleziona un settore</option>
        ${sectors
          .map(
            (sector) => `
          <option value="${sector.id}">${sector.sector_name}</option>
        `
          )
          .join("")}
      `;
      sectorSelect.disabled = false;
    } catch (error) {
      console.error("Error fetching sectors:", error);
      sectorSelect.innerHTML =
        '<option value="">Errore nel caricamento dei settori</option>';
      sectorSelect.disabled = true;
    }
  }

  async handleStep1Submission() {
    // Save form data
    this.planData.plan_name = document.getElementById("planName").value;
    this.planData.plan_date = document.getElementById("planDate").value;
    this.planData.company_id = document.getElementById("companySelect").value;
    this.planData.sector_id = document.getElementById("sectorSelect").value;

    // Move to step 2 and ensure crop data is loaded
    await this.goToStep(2);
  }

  validateStep2Data() {
    const inputs = [
      "plannedN",
      "plannedP",
      "plannedK",
      "plannedCa",
      "plannedMg",
      "plannedS",
    ];

    let isValid = true;
    inputs.forEach((inputId) => {
      const input = document.getElementById(inputId);
      const value = parseFloat(input.value);

      if (isNaN(value) || value < 0) {
        input.classList.add("is-invalid");
        isValid = false;
      } else {
        input.classList.remove("is-invalid");
      }
    });

    return isValid;
  }

  saveStep2Data() {
    // Save the supply program data
    this.planData.supply_program = {
      nitrogen_n: parseFloat(document.getElementById("plannedN").value) || 0,
      phosphorus_p2o5:
        parseFloat(document.getElementById("plannedP").value) || 0,
      potassium_k2o: parseFloat(document.getElementById("plannedK").value) || 0,
      calcium_cao: parseFloat(document.getElementById("plannedCa").value) || 0,
      magnesium_mgo:
        parseFloat(document.getElementById("plannedMg").value) || 0,
      sulfur_so3: parseFloat(document.getElementById("plannedS").value) || 0,
    };
  }

  async goToStep(step) {
    this.currentStep = step;

    // Hide all step contents
    document.querySelectorAll(".step-content").forEach((content) => {
      content.style.display = "none";
    });

    // Show current step content
    const currentContent = document.getElementById(`step${step}Content`);
    if (currentContent) {
      currentContent.style.display = "block";
    }

    // Update progress bar and step indicators
    const progressBar = document.querySelector(".progress");
    if (progressBar) {
      progressBar.innerHTML = this.renderProgressBar();
    }

    const stepIndicators = document.querySelector(
      ".d-flex.justify-content-between.mb-4"
    );
    if (stepIndicators) {
      stepIndicators.innerHTML = this.renderStepIndicators();
    }

    // If moving to step 2, load the crop data
    if (step === 2) {
      await this.loadCropData();
    }
  }

  async loadCropData() {
    try {
      if (!this.planData.sector_id) {
        console.error("No sector ID available");
        return;
      }

      // Get the sector with its crop data
      const sectorResult = await sectorService.getSectorWithCrop(
        this.planData.sector_id
      );

      if (sectorResult.success && sectorResult.data.crops) {
        const crop = sectorResult.data.crops;

        // Update the suggested values
        document.getElementById("suggestedN").textContent =
          crop.nitrogen_n?.toFixed(2) || "-";
        document.getElementById("suggestedP").textContent =
          crop.phosphorus_p2o5?.toFixed(2) || "-";
        document.getElementById("suggestedK").textContent =
          crop.potassium_k2o?.toFixed(2) || "-";
        document.getElementById("suggestedCa").textContent =
          crop.calcium_cao?.toFixed(2) || "-";
        document.getElementById("suggestedMg").textContent =
          crop.magnesium_mgo?.toFixed(2) || "-";
        document.getElementById("suggestedS").textContent =
          crop.sulfur_so3?.toFixed(2) || "-";

        // Pre-fill the planned values with the suggested values
        document.getElementById("plannedN").value =
          crop.nitrogen_n?.toFixed(2) || "";
        document.getElementById("plannedP").value =
          crop.phosphorus_p2o5?.toFixed(2) || "";
        document.getElementById("plannedK").value =
          crop.potassium_k2o?.toFixed(2) || "";
        document.getElementById("plannedCa").value =
          crop.calcium_cao?.toFixed(2) || "";
        document.getElementById("plannedMg").value =
          crop.magnesium_mgo?.toFixed(2) || "";
        document.getElementById("plannedS").value =
          crop.sulfur_so3?.toFixed(2) || "";
      } else {
        console.error("No crop data available for sector");
        throw new Error("No crop data available");
      }
    } catch (error) {
      console.error("Error loading crop data:", error);
      // Show error message to user
      const alert = document.createElement("div");
      alert.className = "alert alert-danger mt-3";
      alert.innerHTML = `
        <i class="bi bi-exclamation-triangle me-2"></i>
        Errore nel caricamento dei dati della coltura
      `;
      document.querySelector("#step2Content").prepend(alert);
    }
  }
}

// Create and export a singleton instance
export const planController = new PlanController();
